import { render, staticRenderFns } from "./ServicePricingSection.vue?vue&type=template&id=821e6944&scoped=true&lang=pug&"
import script from "./ServicePricingSection.vue?vue&type=script&lang=js&"
export * from "./ServicePricingSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicePricingSection.vue?vue&type=style&index=0&id=821e6944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821e6944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
